var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item,i){return _c('v-container',{key:`item_${i}`,class:`list-item flex-shrink-0 pa-3 pl-4 pr-2`,attrs:{"fluid":""}},[_vm._t("list-item")],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }